export default {
  FETCH_DATA: 'noti_fetch_data',
  FETCH_COUNTER_DATA: 'noti_fetch_counter_data',
  UPDATE_QUERY: 'noti_update_query',
  UPDATE_ONE_DATA: 'noti_update_one_data',
  LOAD_MORE_DATA: 'noti_load_more_data',
  UPDATE_LOADING: 'noti_update_loading',
  UPDATE_SELECTED: 'noti_update_selected',
};
